import { render, staticRenderFns } from "./access_wrap.vue?vue&type=template&id=7c39080b&scoped=true&"
import script from "./access_wrap.vue?vue&type=script&lang=js&"
export * from "./access_wrap.vue?vue&type=script&lang=js&"
import style0 from "./access_wrap.vue?vue&type=style&index=0&id=7c39080b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c39080b",
  null
  
)

export default component.exports